import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import '../../operations/fragments/checkout-mutation-result.js';
import '../../operations/fragments/cart-mutation-failures.js';
import '../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../operations/fragments/paypal-payment.js';
import '../../operations/fragments/saved-user-details.js';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-service-store.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import '../../operations/queries/get-checkout-state.js';
import { GET_SAVED_USER_DETAILS } from '../../operations/queries/get-user-details.js';
import '@swc/helpers';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import { toBillingAddress, toPersonalDetails } from '../../utils/user-details-to-shipping-summary-mapper.js';

const useFetchUserDetails = ()=>{
    const [fetchUserDetails, { data , loading , error  }] = useLazyQuery(GET_SAVED_USER_DETAILS);
    const loadUserDetails = React.useCallback((token)=>{
        fetchUserDetails({
            context: {
                forwardHeaders: {
                    Authorization: `Bearer ${token}`
                }
            }
        });
    }, [
        fetchUserDetails
    ]);
    const userData = React.useMemo(()=>{
        if (!data || !data.me) return undefined;
        const { defaultBillingAddress , personalDetails , email , preferredStore  } = data.me;
        return {
            billingAddress: toBillingAddress(defaultBillingAddress),
            contactDetails: toPersonalDetails(personalDetails, email),
            globalStoreId: preferredStore === null || preferredStore === void 0 ? void 0 : preferredStore.globalStoreId
        };
    }, [
        data
    ]);
    return React.useMemo(()=>({
            error,
            loading,
            userData,
            loadUserDetails
        })
    , [
        loadUserDetails,
        error,
        userData,
        loading
    ]);
};

export { useFetchUserDetails };
//# sourceMappingURL=use-fetch-user-details.js.map
